import React from "react";
import { Button } from "@/components/button/Button";
import { Card } from "@/components/card/Card";
import { XIcon as X } from "@phosphor-icons/react";

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error?: any }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }
  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }
  componentDidCatch(error: any, errorInfo: any) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }
  public closeWindow() {
    window.parent.postMessage("sc-closeIframe", "*");
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="h-[100vh] w-full flex justify-center items-center bg-fixed overflow-hidden">
          {/* Main Chat Container */}
          <div className="h-[100vh] w-full mx-auto max-w-lg flex flex-col rounded-md overflow-hidden relative border border-neutral-300">
            <div className="chat-bot-header px-4 py-3 border-b border-neutral-300 flex items-center gap-3 sticky top-0 z-10">
              <div className="flex-1">
                <h2 className="mt-1 font-bold text-lg text-headline">
                  Kois Center Collective Intelligence
                </h2>
              </div>
              <Button
                variant="ghost"
                size="md"
                shape="square"
                className="rounded-full h-9 w-9"
                onClick={() => this.closeWindow()}
              >
                <X size={20} />
              </Button>
            </div>
            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              <div className="h-full flex items-center justify-center">
                <Card className="w-full rounded-lg p-10 btn-secondary max-w-md mx-auto intro-bg">
                  <div className="text-center space-y-2">
                    <h2 className="text-base">
                      We're sorry, an unexpected error occurred
                    </h2>
                    <p className="text-base">
                      Please refresh the page or try again later. If the problem
                      persists, please contact the site administrator.
                    </p>
                    <p className="text-base text-red-600">
                      Error: {this.state.error?.message || "Unknown error"}
                    </p>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
